export default __webpack_public_path__ + "static/media/acolyte_001.4b765009.jpg";